import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IGetUser, IUserData } from '../../../types/users/IUser';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export const getUsersAsync = async (users: IGetUser[]): Promise<IUserData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IUserData[]>(`/lender/v2/admin/users/details`, { users })
    .then((response) => response.data)
    .catch(axiosErrorHandler);
